__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@aviv-unified-frontend/branded-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@aviv-csnt/react", "3.0.1", () => (() => (__webpack_require__(4570))), 1);
			register("@aviv-dxp/react-thor", "2.23.0", () => (() => (__webpack_require__(5217))), 1);
			register("@aviv-trak/feature-flagging", "0.3.0", () => (() => (__webpack_require__(6403))), 1);
			register("@aviv-unified-frontend/runtime/authentication", "9.0.0", () => (() => (__webpack_require__(8698))), 1);
			register("@aviv-unified-frontend/runtime/brand", "9.0.0", () => (() => (__webpack_require__(339))), 1);
			register("@aviv-unified-frontend/runtime/environment", "9.0.0", () => (() => (__webpack_require__(7403))), 1);
			register("@aviv-unified-frontend/runtime/fetcher", "9.0.0", () => (() => (__webpack_require__(1965))), 1);
			register("@aviv-unified-frontend/runtime/head", "9.0.0", () => (() => (__webpack_require__(8428))), 1);
			register("@aviv-unified-frontend/runtime/i18n", "9.0.0", () => (() => (__webpack_require__(2542))), 1);
			register("@aviv-unified-frontend/runtime/lifecycle", "9.0.0", () => (() => (__webpack_require__(400))), 1);
			register("@aviv-unified-frontend/runtime/monitoring", "9.0.0", () => (() => (__webpack_require__(9568))), 1);
			register("@aviv-unified-frontend/runtime/router", "9.0.0", () => (() => (__webpack_require__(2965))), 1);
			register("@gemini/core", "2.25.0", () => (() => (__webpack_require__(4869))), 1);
			register("@react-aria/focus", "3.21.0", () => (() => (__webpack_require__(3728))), 1);
			register("@react-aria/focus", "3.21.1", () => (() => (__webpack_require__(3845))), 1);
			register("@react-aria/i18n", "3.12.11", () => (() => (__webpack_require__(9086))), 1);
			register("@react-aria/i18n", "3.12.12", () => (() => (__webpack_require__(5287))), 1);
			register("@react-aria/interactions", "3.25.4", () => (() => (__webpack_require__(4814))), 1);
			register("@react-aria/interactions", "3.25.5", () => (() => (__webpack_require__(169))), 1);
			register("@react-aria/overlays", "3.28.0", () => (() => (__webpack_require__(5105))), 1);
			register("@react-aria/ssr", "3.9.10", () => (() => (__webpack_require__(1332))), 1);
			register("@react-aria/toast", "3.0.6", () => (() => (__webpack_require__(3545))), 1);
			register("@react-aria/utils", "3.30.0", () => (() => (__webpack_require__(2953))), 1);
			register("@react-aria/utils", "3.30.1", () => (() => (__webpack_require__(1140))), 1);
			register("@react-stately/overlays", "3.6.18", () => (() => (__webpack_require__(9109))), 1);
			register("@react-stately/toast", "3.1.2", () => (() => (__webpack_require__(3580))), 1);
			register("react-dom/client", "19.1.1", () => (() => (__webpack_require__(8606))), 1);
			register("react-dom/server", "19.1.1", () => (() => (__webpack_require__(9764))), 1);
			register("react-dom", "19.1.1", () => (() => (__webpack_require__(7365))), 1);
			register("react/jsx-runtime", "19.1.1", () => (() => (__webpack_require__(1273))), 1);
			register("react", "19.1.1", () => (() => (__webpack_require__(3917))), 1);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};